import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";

import { LoginPage } from "./LoginPage";

// Render the login page immediately; the isInitialized check runs in
// the background and only forces a redirect if the project is not set up.
export const StartPage = () => {
  const dataProvider = useDataProvider<CrmDataProvider>();

  // Fire the init check but don't block rendering on it
  useQuery({
    queryKey: ["init"],
    queryFn: async () => dataProvider.isInitialized(),
    staleTime: 1000 * 60 * 5, // cache for 5 minutes
    retry: false,
  });

  return <LoginPage />;
};
